import { render, staticRenderFns } from "./Forward.vue?vue&type=template&id=123fcb2e&scoped=true&"
import script from "./Forward.vue?vue&type=script&lang=js&"
export * from "./Forward.vue?vue&type=script&lang=js&"
import style0 from "./Forward.vue?vue&type=style&index=0&id=123fcb2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123fcb2e",
  null
  
)

export default component.exports